import { produce } from 'immer';

import * as Types from './types';
import { actionTypes } from './constants';

export const defaultState: Types.IPaymentsState = {
    beforeWithdrawHooks: []
};

export const reducer = produce((draftState, action: Types.TPaymentsAction): Types.IPaymentsState | void => {
    switch (action.type) {
        case actionTypes.ADD_BEFORE_WITHDRAW_HOOK: {
            const { beforeWithdrawHooks } = draftState;

            Object.assign(draftState, {
                beforeWithdrawHooks: beforeWithdrawHooks.concat([action.payload])
            });

            break;
        }

        default: {
            break;
        }
    }
}, defaultState);
